export function stringify(data: any) {
  if (data instanceof FormData) return stringifyFormData(data)
  let result: string = ''
  if (typeof data === 'object') {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const element = data[key]
        result += `&${key}=${element}`
      }
    }
    if (result.length > 0) result = result.substr(1)
  }
  return result
}

export function stringifyFormData(data: FormData): string {
  let result: string = ''
  data.forEach((value, key) => {
    result += `&${key}=${value}`
  })
  if (result.length > 0) result = result.substr(1)
  return result
}

export const MillisecondsOfOneDay: number = 1000 * 60 * 60 * 24

export function setDateToStart(date: Date): Date {
  date.setHours(0, 0, 0, 0)
  return date
}
export function accAdd(...arg: any[]) {
  let lens = arg.map(num => {
    try {
      return num.toString().split('.')[1].length
    } catch (error) {
      return 0
    }
  })
  let m = Math.pow(10, Math.max(...lens))
  return (
    arg.reduce((init, curr) => {
      return init + curr * m
    }, 0) / m
  )
}
export function accSub(...arg: any[]) {
  return accAdd(...arg.map((num, index) => (index >= 1 ? -num : num)))
}
export function accMul(...arg: any[]) {
  let m = arg.reduce((init, curr) => {
    try {
      return init + curr.toString().split('.')[1].length
    } catch (error) {
      return init
    }
  }, 0)
  return (
    arg.reduce((init, curr) => {
      return init * Number(curr.toString().replace('.', ''))
    }, 1) / Math.pow(10, m)
  )
}
// 节流
export function throttle(fn, gapTime) {
  if (gapTime == null || gapTime == undefined) {
      gapTime = 1500
  }

  let _lastTime = null

  // 返回新的函数
  return function () {
      let _nowTime = + new Date()
      if (_nowTime - _lastTime > gapTime || !_lastTime) {
          fn.apply(this, arguments)   //将this和参数传给原函数
          _lastTime = _nowTime
      }
  }
}


export function accDiv(...arg: any[]) {
  return arg.reduce((init, curr, index) => {
    let r1, r2
    if (index === 0) {
      return curr
    } else {
      try {
        r1 = init.toString().split('.')[1].length
      } catch (error) {
        r1 = 0
      }
      try {
        r2 = curr.toString().split('.')[1].length
      } catch (error) {
        r2 = 0
      }
      return (
        (Number(init.toString().replace('.', '')) /
          Number(curr.toString().replace('.', ''))) *
        Math.pow(10, r2 - r1)
      )
    }
  }, 0)
}
export function formatDate(date: any, format: string = 'YYYY-MM-DD HH:mm:ss') {
  if (!(date instanceof Date)) {
    date = new Date(date)
    if (isNaN(date)) {
      console.error('时间格式错误')
      return ''
    }
  }

  var z = {
    Y: date.getFullYear(),
    M: date.getMonth() + 1,
    D: date.getDate(),
    H: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
  }
  return format.replace(/(Y+|M+|D+|H+|m+|s+)/g, (v: string) => {
    return String((v.length > 1 ? '0' : '') + (z as any)[v.slice(-1)]).slice(-(v.length > 2 ? v.length : 2))
  })
}

/**
 * 格式化数字终级版
 * @param {Number|String} value 要格式化的值
 * @param {Number} precision 精度(小数位数),会自动去掉小数末尾的0
 * @param {String} seperator 千分位分隔符（没有就不加分隔符）
 */
export function formatNumber(value: number | string, precision = 2, seperator: string = '') {
  if (!value) return 0
  const numStr = typeof value === 'string' ? value.replace(/,/g, '') : `${value || ''}`
  const arr = numStr.split('.')
  let strInt = arr[0]
  let strFractional = arr[1] || ''
  if (seperator) {
    strInt = strInt.replace(/\d{1,3}(?=(\d{3})+$)/g, `$&${seperator}`)
  }
  precision = Math.max(0, precision)
  if (strFractional.length > precision) {
    strFractional = strFractional.substr(0, precision)
  }
  if (strFractional.length > 0) {
    strFractional = strFractional.replace(/0+$/, '')
  }
  if (strFractional.length > 0) {
    return `${strInt}.${strFractional}`
  }
  return strInt
}

/**
 * 依次替换模板字符串中的特殊字符<>
 * @param temp 模板字符串
 * @param _ 用来替换的值的数组
 */
export function replaceTemplateString(temp: string, ..._: any[]) {
  let result = temp
  for (let i = 0; i < _.length; i++) {
    const item = arguments[i]
    result = result.replace(`{${i}}`, item)
  }
  return result
}

export function awaitWrap<T, U = any>(promise: Promise<T>): Promise<[U | null, T | null]> {
  return promise.then<[null, T]>((data: T) => [null, data]).catch<[U, null]>(err => [err, null])
}

function getNumberOfDecimalPlaces(num: number | string): number {
  let numStr: string = String(num)
  numStr = numStr.replace(/\.?0+$/, '')
  const dotIndex: number = numStr.indexOf('.')
  return dotIndex === -1 ? 0 : numStr.length - dotIndex - 1
}

function getMaxNumberOfDecimalPlaces(..._: any): number {
  const numbers: (number | string)[] = _
  const nums: number[] = (numbers.map(getNumberOfDecimalPlaces) as any) as number[]
  return Math.max(...nums)
}

/**
 * 浮点数小数点左移
 * @param num
 * @param digts 位数
 */
function decimalLeftShift(num: number | string, digts: number): number {
  return Math.round(Number(num) * Math.pow(10, digts))
}

export function asyncLoadJs(url: string) {
  return new Promise((resolve, reject) => {
    const srcArr = document.getElementsByTagName('script')
    for (let i = 0; i < srcArr.length; i++) {
      const src = srcArr.item(i)
      if (src && src.src === url) {
        // resolve()
        return
      }
    }
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = url
    document.body.appendChild(script)
    script.onload = resolve
    script.onerror = reject
  })
}

export function transformObjectValueToArray(obj: any): any[] {
  const arr: any[] = []
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      arr.push(obj[key])
    }
  }
  return arr
}

export function handleTableData(dataItem: any) {
  if (Object.prototype.toString.call(dataItem) !== '[object Object]') {
    console.error('dataItem Object 类型')
    return
  }
  Object.entries(dataItem).forEach(([key, value]) => {
    if (/^-?(\d)+(.\d+)?$/.test(value as string)) {
      dataItem[key] = formatNumber(value as string)
    }
    if (['', 'undefined', null, 'null'].some(val => value === val)) {
      dataItem[key] = '-'
    }
  })
}

export function locationSearchToJson(location: any) {
  let result: any = {}
  const seach = location.search.replace('?', '')
  const seachArr = seach.split('&')
  seachArr.forEach((seachParam: string) => {
    const [key, value] = seachParam.split('=')
    if (key && value) result[key] = value
  })
  return result
}

export function safeJsonParse(stringValue: string | null | undefined): any {
  if (isEmpty(stringValue)) return stringValue
  try {
    return JSON.parse(stringValue!)
  } catch (error) {
    return null
  }
}

export function isEmpty(value: any): boolean {
  return value === null || value === undefined
}

export function isNumber(value: string): boolean {
  if (typeof value === 'number') {
    return true
  }
  if (typeof value !== 'string') {
    return false
  }
  // TODO: 未判断超过最大值
  var regPos = /^\d+(\.\d+)?$/ // 非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ // 负浮点数
  if (regPos.test(value) || regNeg.test(value)) {
    return true
  } else {
    return false
  }
}

export function getNumberPrecision(num: number | string): number {
  let numStr: string = String(num)
  numStr = numStr.replace(/\.?0+$/, '')
  const dotIndex: number = numStr.indexOf('.')
  return dotIndex === -1 ? 0 : numStr.length - dotIndex - 1
}

const valueToString2TypeMap: { [key: string]: string } = {
  '[object Boolean]': 'boolean',
  '[object Number]': 'number',
  '[object String]': 'string',
  '[object Function]': 'function',
  '[object Array]': 'array',
  '[object Date]': 'date',
  '[object RegExp]': 'regExp',
  '[object Undefined]': 'undefined',
  '[object Null]': 'null',
  '[object Object]': 'object',
}

export function getType(obj: any): string {
  const toString = Object.prototype.toString
  return valueToString2TypeMap[toString.call(obj)] as string
}

export function deepClone(src: any, tar?: any): any {
  const type = getType(src)
  if (type === 'array') {
    tar = tar || []
    src.forEach((item: any) => tar.push(deepClone(item)))
    return tar
  } else if (type === 'object') {
    tar = tar || {}
    for (let key in src) {
      tar[key] = deepClone(src[key])
    }
    return tar
  } else {
    return src
  }
}
